'use client'
import { memo } from 'react'
import styled from 'styled-components'
import { AnimatePresence, motion, type Variants } from 'motion/react'
import { mq, vw, hideScrollbar, getP93_2 } from '@/styles'
import { useTranslator } from '@/hooks'

interface IMarqueeSlider {
  uniqueClass?: any,
  inverted?: boolean,
}

export const MarqueeSlider = memo<IMarqueeSlider>(({ uniqueClass = 'marquee-item' , inverted = false }) => {
  const { t } = useTranslator()
  return (
    <>
      <MarqueeSliderWrapper className='marquee' $inverted={inverted}>
        <AnimatePresence>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <motion.p key='p1' className={uniqueClass} animate='animate' variants={variantsText} >&nbsp;<img src='/images/svg/i--prize.svg' alt='prize icon' /> {t('home.section_prize.title')} </motion.p> <motion.p key='p2' className={uniqueClass}  animate='animate'  variants={variantsText} >&nbsp;<img src='/images/svg/i--prize.svg' alt='prize icon' /> {t('home.section_prize.title')} </motion.p>
        </AnimatePresence>
      </MarqueeSliderWrapper>
    </>
  )
})


const MarqueeSliderWrapper = styled.div<any>`
  ${hideScrollbar()}
  background-color:none;
  display: flex;
  overflow-x: hidden;
  padding: ${vw(20, 'mobile')} 0 ${vw(120, 'mobile')};
  position: relative;

  ${mq.greaterThan('tablet')} {
    padding: ${vw(100, 'desktop')} 0  ${vw(188, 'desktop')};
  }

  p {
    ${getP93_2()}
    color: ${({ $inverted }) => $inverted ? 'black' : 'var(--color-white)'};
    white-space: nowrap;

    img {
      height: ${vw(58, 'mobile')};
      width: ${vw(58, 'mobile')};

      ${mq.greaterThan('tablet')} {
        height: ${vw(128, 'desktop')};
        width: ${vw(128, 'desktop')};
      }
    }
  }
`

const variantsText:Variants = {
  animate: {
    x: '-100%',
    transition: {
      duration: 10,
      repeat: Infinity,
      ease: 'linear'
    }
  }
} as const
